// import uiRouter from "@uirouter/angularjs";
import uiRouter from 'angular-ui-router';

import ngAnimate from 'angular-animate';
import uiBootstrap from 'angular-ui-bootstrap';
import AngularAria from 'angular-aria';
import AngularMaterial from 'angular-material';
import DataTable from 'angular-material-data-table';
import DataTableHeader from 'angular-fixed-table-header';
import ngMessages from 'angular-messages';
import uiGrid from 'angular-ui-grid'; // it's used do not delete it
import mdPickers from "mdPickers";
import moment from 'moment';
import dragAndDrop from 'angular-drag-and-drop-lists';
import uiTree from 'angular-ui-tree';
import * as _str from 'underscore.string';
import { ErrorLogger } from './utils/errorlogger';

//****

import 'jquery';
import 'bootstrap';
import 'bootstrap/less/bootstrap.less';
import 'bootstrap/dist/js/bootstrap.min';
import componentsNewDashBoard from './app/authorized/newDashBoard/components';
import shared from './app/authorized/newDashBoard/shared';
import reduxForNewDashBoard from './app/authorized/newDashBoard/redux';
import 'ui-select';
import 'ui-select/dist/select.css';
import 'angular-gridster';
import 'angular-gridster/dist/angular-gridster.css';

import ngSanitize from './offlineScripts/angular-sanitize';
//new

import 'bootstrap-daterangepicker';
import 'bootstrap-daterangepicker/daterangepicker.scss';
import 'angular-daterangepicker';

import 'angular-translate/dist/angular-translate';
import 'angular-translate-loader-static-files';
import 'angular-translate-storage-cookie';
import 'angular-translate-storage-local';
import 'ng-split';
import './app/common/directives/ng-split-custom'

import 'ng-file-upload';
require("dbm.font.json");
require('source-map-support').install()
import dynamicSref from "./utils/dynamic-sref";
import { DynamicBrowserTitle } from "./utils/dynamic-browser-title.service";
import { securityActions } from "./store/reducers/securityReducer";

import { ProjectsLocalHistoryService } from './services/history/projectsLocalHistoryService';
import { LogsLocalHistoryService } from './services/history/logsLocalHistoryService';
import { FavoriteProjectsService } from './services/favoriteProjectsService'
import { ProcessDetailsModalService } from './services/models/processDetailsModalService';
import { ProcessDetailsPopupComponent, ScrollToBottom } from './app/common/components/processDetailsPopup/processDetailsPopup';

import { TranformtionTextToShortTextWithEllipsis } from './app/common/pipes/shortTextWithEllipsis';
import { ChangeEnumJobNameToName } from './app/common/pipes/ChangeEnumJobNameToName';
import { DatabaseTypeItem } from './app/common/pipes/dbTypeItem';
import { SearchNameOrId } from './app/common/pipes/searchNameOrId';

import { AppComponent } from './app/app';
import { PopUpModal } from './app/common/components/popUpModal/popUpModal';

import { routerConfig } from './router';
import { fileInput } from './app/common/directives/file-input';
import { compileTemplate } from './app/common/directives/compileTemplate';
import { inputSelected } from './app/common/directives/inputSelected';

import { scrollDetector } from './app/common/directives/scrollDetector';

import { Store } from './store/store';
import { Utils } from './utils/util';

import AuthModule from './app/authentication';
import AuthorizedModule from './app/authorized/module';
import 'angular-ivh-treeview';
import { JobCompletitionService } from './services/jobCompletitionService';
import { AuthorizationService } from './services/authorizationService';
import { DbTypeService } from './services/dbTypeService';
import { ProjectsComparatorService } from './services/projectsComparator';
import { PackagesLocalHistoryService } from './services/history/packagesLocalHistoryService';
import { FileUploader } from "@src/utils/file-uploader";
import 'ng-infinite-scroll';
window.errorLogger = new ErrorLogger();
const modelToLoad = [
    'pascalprecht.translate',
    'ui.grid',
    'ui.grid.autoResize',
    'ui.select', //check this
    'ui.grid.cellNav',
    'ui.grid.edit',
    'ui.grid.expandable',
    'ui.grid.resizeColumns',
    'ui.grid.pinning',
    'ui.grid.selection',
    'ui.grid.moveColumns',
    'ui.grid.infiniteScroll',
    'googlechart',
    'dndLists',
    'ngFileUpload',
    'ui.tree',
    mdPickers,
    'gridster',
    'ui.select',
    'ngSanitize',
    reduxForNewDashBoard,
    shared,
    'daterangepicker',
    componentsNewDashBoard,
    'ng-split',
    'ng-split-custom',
    ngMessages,
    'ui.bootstrap',
    uiRouter, // 'ui.router.upgrade',
    ngAnimate,
    AngularAria,
    AngularMaterial,
    DataTable,
    DataTableHeader,
    AuthModule.name,
    AuthorizedModule.name,
    'ivh.treeview',
    'infinite-scroll'
];



window.cTransformResponse = function (data, headers, action) {
    headers.CustomErrorHandling = action.customErrorHandling;
    headers.SilentRequest = action.silentRequest;
    if (headers("Content-Type") == null) {
        return;
    }
    if (!headers("Content-Type").startsWith("application/json")) {
        return data;
    }
    return angular.fromJson(data);
};
window.createCookie = (name, value, days) => {
    var expires = "";
    if (days) {
        var date = new Date();
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + value + expires + "; path=/";
}

window.readCookie = (name) => {
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
}

window.eraseCookie = (name) => {
    window.createCookie(name, "", -1);
}
//check this
uiSelectWrap.$inject = ['$document', 'uiGridEditConstants'];
function uiSelectWrap($document, uiGridEditConstants) {
    return function link($scope, $elm, $attr) {
        $document.on('click', docClick);

        function docClick(evt) {

            if ($(evt.target).closest('.ui-select-container').length === 0) {
                $scope.$emit(uiGridEditConstants.events.END_CELL_EDIT);
                $document.off('click', docClick);
            }
        }
    };
}



dbMaestroSecurityConfig.$inject = ['$provide', '$httpProvider'];

function dbMaestroSecurityConfig($provide, $httpProvider) {
    interceptorFunc.$inject = ['$q', '$injector', '$filter'];
    function interceptorFunc($q, $injector, $filter) {
        let processedTimeoutRequest = false;
        let timedOutRequests = [];
        const $translate = $filter('translate');
        const errorCallback = (msg) => {
            let $state = $injector.get('$state');
            let callbacks = null;
            if (msg.includes('Invalid Project, (')) {
                callbacks = [() => { $state.go('app.authorized.projects') }];
            }
            return callbacks;
        }
        return {
            'request': async function (config) {
                let authService = $injector.get('authService');
                let sessionService = $injector.get('sessionService');
                let AuthType = JSON.parse(localStorage.getItem('AuthType'))
                if (sessionService.user && sessionService.user != null) {
                    if (AuthType != null) {
                        if (AuthType == 'oidc') {
                            await authService.RefreshToken();
                        }
                        else {
                            if (sessionService.user != null && !config.url.includes('Security/RefreshToken')) {
                                if (authService.isExpired() == false) {
                                    let user = sessionService ? sessionService.user : null;
                                    let store = $injector.get('store');
                                    const action = {
                                        type: securityActions.REFRESH_TOKEN, payload: {
                                            access_token: user.access_token,
                                            refresh_token: user.refresh_token
                                        }
                                    };
                                    const res = await store.dispatch(action);
                                    sessionService.user = res.data
                                }
                            }
                        }
                    }
                }

                if (config.SilentRequest != true) {
                    let $rootScope = $injector.get('$rootScope');
                    $rootScope.addLoader();
                }
                let user = sessionService ? sessionService.user : null;
                if (user !== null) {
                    // config.headers.Accept = "application/json;charset=utf-8";
                    config.headers.Authorization = `Bearer ${user.access_token}`;
                }
                return config;
            },
            'requestError': function (rejection) {
                if (rejection.headers.SilentRequest != true) {
                    let $rootScope = $injector.get('$rootScope');
                    $rootScope.removeLoader();
                }
                return $q.reject(rejection);
            },
            'response': function (response) {
                if (response.headers.SilentRequest != true) {
                    let $rootScope = $injector.get('$rootScope');
                    $rootScope.removeLoader();
                }
                if (response.data.TEST_RUNNING == "Running") {
                    return response;
                }
                if (response.data.IsSuccesfull === undefined) {
                    return response;
                }
                response.data["status"] = response.data["StatusCode"];
                delete response.data["StatusCode"];

                if (response.data.IsSuccesfull) {
                    response.data["data"] = response.data["Result"];
                    delete response.data["Result"];
                    return response.data;
                }
                else {
                    const dialogManagerService = $injector.get('dialogManagerService');
                    let errorMesage = $translate("UNEXPECTED_ERROR");
                    switch (response.data.status) {
                        case 401: //Un authorized
                            errorMesage = "UnAuthorized"
                            let $state = $injector.get('$state');
                            let sessionService = $injector.get('sessionService');
                            let store = $injector.get('store');
                            sessionService.remove(`user_${window.__env.config.versionRM}`);
                            store.dispatch({
                                type: securityActions.LOGOUT,
                                callback: () => $state.go('app.auth.login')
                            });
                            break;
                        case 400:
                        case 403: // forbidden
                        case 439: //custom error
                            {
                                const msgFormat = (response.data.StatusMessage && response.data.StatusMessage.trim().slice(-1) == ".") ?
                                    $translate("CUSTOM_ERROR") : $translate("CUSTOM_ERROR_WITH_POINT");
                                errorMesage = _str.sprintf(msgFormat, response.data.StatusMessage);
                                break;
                            }
                    }

                    if (errorMesage != "UnAuthorized") {
                        if (errorMesage != $translate("UNEXPECTED_ERROR")) {
                            errorMesage = response.data.StatusMessage ? response.data.StatusMessage : '';
                            if (errorMesage.includes('Invalid Project, (')) {
                                let $state = $injector.get('$state');
                                $state.go('app.authorized.projects')
                                errorMesage = errorMesage.replace(",", "");
                            }

                        }
                        dialogManagerService.showGlobalErrorDialog({ title: $translate('ERROR'), text: errorMesage });
                    }

                    return $q.reject(response.data);
                }
            },
            'responseError': async function (rejection) {
                console.log(rejection)
                let $rootScope = $injector.get('$rootScope');
                if (rejection.headers != undefined) {
                    if (rejection.headers.SilentRequest != true) {
                        $rootScope.removeLoader();
                    }
                    if (rejection.headers.CustomErrorHandling == true) {
                        return $q.reject(rejection)
                    }
                }
                let dialogManagerService = $injector.get('dialogManagerService');
                switch (rejection.status) {
                    case 400: {
                        const errorMesage = rejection.data ? rejection.data : '';
                        dialogManagerService.showGlobalErrorDialog({ title: $translate('ERROR'), text: errorMesage });
                        break;
                    }
                    case 500: {
                        const errorMesage = rejection.data ? rejection.data : rejection;
                        dialogManagerService.showGlobalErrorDialog({ title: $translate('ERROR'), text: errorMesage });
                        break;
                    }
                    case 401: //Un authorized
                        errorMesage = "UnAuthorized"
                        let $state = $injector.get('$state');
                        let sessionService = $injector.get('sessionService');
                        let store = $injector.get('store');
                        sessionService.remove(`user_${window.__env.config.versionRM}`);
                        store.dispatch({
                            type: securityActions.LOGOUT,
                            callback: () => $state.go('app.auth.login')
                        });
                        break;
                    case 403: // forbidden
                        dialogManagerService.showGlobalErrorDialog({ title: $translate("ERROR"), text: rejection.data });
                        break;
                    case 439: //custom error
                        {
                            const msgFormat = (rejection.data && rejection.data.trim().slice(-1) == ".") ?
                                $translate("CUSTOM_ERROR") : $translate("CUSTOM_ERROR_WITH_POINT");
                            const msg = _str.sprintf(msgFormat, rejection.data);
                            dialogManagerService.showGlobalErrorDialog({ title: $translate("ERROR"), text: msg, }, () => errorCallback(msg));
                            break;
                        }
                    case 460: //custom error
                        const msgLicense = rejection.data ? rejection.data : '';
                        dialogManagerService.showGlobalErrorDialog({ title: $translate('ERROR'), text: msgLicense });
                        break;
                    case -1: //time out
                        var checkingWithoutRetry = () => {
                            if (rejection.config && rejection.config.data && (!rejection.config.data.projectId)) {
                                var last = rejection.config.url.split("/").pop();
                                if (last == 'Commit' || last == 'Save')
                                    return true;
                            }
                            return false;
                        }
                        if (rejection.headers && (rejection.headers.SilentRequest != true || rejection.headers.silentRequest != true)) {
                            timedOutRequests.push(rejection.config);
                            $rootScope.loaders = [];
                            const dialogData = {
                                title: $translate("ERROR"),
                                text: $translate("ERROR_TIME_OUT"),
                                hasConfirm: checkingWithoutRetry(),
                                confirmText: 'Retry',
                                cancelText: 'Ok'
                            }
                            const onConfirm = () => {
                                const $http = $injector.get('$http');
                                timedOutRequests.forEach(cfg => $http(cfg));
                                timedOutRequests = [];
                            };
                            dialogManagerService.showTimeoutDialog(dialogData, onConfirm);
                        }
                        break;
                    default:
                        dialogManagerService.showErrorDialog({ title: $translate("ERROR"), text: $translate("UNEXPECTED_ERROR") });
                }
                return $q.reject(rejection);
            }
        }
    }

    $provide.factory("dbMaestroSecurityHttpInterceptor", interceptorFunc);
    $httpProvider.interceptors.push("dbMaestroSecurityHttpInterceptor");
    $provide.factory("timeoutHttpIntercept", ['$rootScope', '$q', function ($rootScope, $q) {
        return {
            'request': function (config) {
                if (!config.timeout)
                    config.timeout = window.__env.config.timeout; //  default 1 min
                return config;
            }
        };
    }]);
    $httpProvider.interceptors.push('timeoutHttpIntercept');
}

import { downgradeInjectable } from '@angular/upgrade/static';
import { DialogManagerService, SessionService, AuthService } from './services';

let app = angular.module('app', modelToLoad)
    .factory('store', downgradeInjectable(Store))
    .factory('dialogManagerService', downgradeInjectable(DialogManagerService))
    .factory('sessionService', downgradeInjectable(SessionService))
    .factory('authService', downgradeInjectable(AuthService))
    /* hybrid routing
    .config(['$urlServiceProvider', ($urlService) => {
        return $urlService.deferIntercept()
    }])*/
    .constant('consts', require("./constants/consts").consts)
    .constant('api', require("./constants/api").api)
    .constant('statuses', require("./constants/jobStatuses").jobStatuses)
    .constant('jobDetailsStatuses', require("./constants/jobDetailsStatuses").jobDetailsStatuses)
    .constant('uiCodemirrorConfig', require("./constants/uiCodemirrorConfig").codeMirrorConfig)
    .directive("dynamicSref", dynamicSref)
    .directive('scrollToBottom', ScrollToBottom.Factory())
    .directive("fileInput", fileInput)
    .directive("scrollDetector", scrollDetector)
    .directive("compileTemplate", compileTemplate)
    .directive("inputSelected", inputSelected)
    .directive('uiSelectWrap', uiSelectWrap) //check this
    .service("dynamicBrowserTitle", DynamicBrowserTitle)
    .service('utils', Utils)
    .service('popUpModal', PopUpModal)
    .service('logsLocalHistoryService', LogsLocalHistoryService)
    .service('projectsLocalHistoryService', ProjectsLocalHistoryService)
    .service('packagesLocalHistoryService', PackagesLocalHistoryService)
    .service('fileUploader', FileUploader)
    .service('processDetailsModalService', ProcessDetailsModalService)
    .service('favoriteProjectsService', FavoriteProjectsService)
    .service('jobCompletitionService', JobCompletitionService)
    .service('projectsComparatorService', ProjectsComparatorService)
    .service('authorizationService', AuthorizationService)
    .service('dbTypeService', DbTypeService)
    .component('processDetailsPopup', new ProcessDetailsPopupComponent())
    .component('app', AppComponent)
    .filter(TranformtionTextToShortTextWithEllipsis.name, TranformtionTextToShortTextWithEllipsis.filter)
    .filter(ChangeEnumJobNameToName.name, ChangeEnumJobNameToName.filter)
    .filter(DatabaseTypeItem.name, DatabaseTypeItem.filter)
    .filter(SearchNameOrId.name, SearchNameOrId.filter)
    .config(routerConfig)
    .config(['$compileProvider', function ($compileProvider) {
        $compileProvider.aHrefSanitizationWhitelist(/^\s*(https?|file|ftp|blob):|data:image\//);
    }])
    .config(['$httpProvider', function ($httpProvider) {
        $httpProvider.interceptors.push(function () {
            return {
                'request': function (config) {
                    let busted = false;
                    if (config.url.match(window.__env.remoteRest.host)) {
                        busted = true;
                    }
                    if (busted) {
                        config.url += ((config.url.indexOf('?') > -1) ? '&' : '?')
                            + config.paramSerializer({ v: new Date().getTime() });
                    } else if (config.url.indexOf('no-cache') > -1) {
                        // if the cached URL contains 'no-cache' then remove it from the cache
                        config.cache.remove(config.url);
                        config.cached = false;
                    }
                    return config;
                }
            }
        });
    }])
    .config(['$mdDateLocaleProvider', ($mdDateLocaleProvider) => { //format DatePicker
        $mdDateLocaleProvider.formatDate = function (date) {
            return date
                ? date.getDate() + '/' + (date.getMonth() + 1) + '/' + date.getFullYear()
                : '';
        };
        $mdDateLocaleProvider.parseDate = function (dateString) {
            var m = moment(dateString, 'D/M/YYYY', true).utc();
            return m.isValid() ? m.toDate() : new Date(NaN);
        }
    }])
    .config(['$mdThemingProvider', ($mdThemingProvider) => { //for checkbox
        $mdThemingProvider.theme('default')
            .primaryPalette('blue-grey')
            .accentPalette('grey', { 'default': '100' });
    }])
    .config(['$translateProvider', ($translateProvider) => { //multi languages
        const _prefix = 'en';
        $translateProvider.useStaticFilesLoader({
            prefix: `languages/content-${_prefix}/`,
            suffix: `.json?v=${window.__env.config.versionRM}`
        });
        $translateProvider.preferredLanguage(_prefix);
        $translateProvider.useSanitizeValueStrategy('escape');
    }])
    .run(['store', 'sessionService', '$rootScope', 'authorizationService', '$state',
        '$filter', 'dialogManagerService', '$window', (store, sessionService, $rootScope, authorizationService, $state, $filter, dialogManagerService, $window) => {
            const $translate = $filter('translate');
            const user = sessionService.user;
            const shouldAuthorizeUser = (isAuthorized, toStateName, fromStateName, isEditMode) => {
                return isAuthorized && toStateName != fromStateName && !isEditMode;
            }

            //If user does not exist, redirect to login page (TDB: need to test when token is not valid)
            //if(user == null || user.access_token == null)
            //{
            //    console.log('DENY : Redirecting to Login');
            //    
            //    $state.go('app.auth.login');            
            //}

            $rootScope.addLoader = () => {
                if ($rootScope.loaders == null) {
                    $rootScope.loaders = [];
                }
                if ($rootScope.loaders.length == 0) {
                    $rootScope.loaders.push({ name: 'testLoader' });
                }
            };
            $rootScope.removeLoader = () => {
                if ($rootScope.loaders == null || $rootScope.loaders.length == 0) {
                    return;
                }
                $rootScope.loaders.pop();
            };
            $rootScope.$on("$stateChangeStart", async (event, toState, toParams, fromState) => {
                if (user) {
                    let editMode = store.getState().project.editMode;
                    if (shouldAuthorizeUser(authorizationService.isAuthorized, toState.name, fromState.name, editMode)) {
                        event.preventDefault();
                        let isAuthorized = await authorizationService.authorize(user.username, toState.name);
                        if (isAuthorized) {
                            $state.go(toState, toParams);
                        } else {
                            dialogManagerService.showErrorDialog({ title: $translate('ERROR'), text: $translate('ERROR_USER_AUTH') });
                        }
                    } else {
                        authorizationService.isAuthorized = false;
                    }
                }
            });
        }])
    .config(dbMaestroSecurityConfig);

if (!window.__env.enableDebug) {
    app.factory('$exceptionHandler', function () {
        return function errorCatcherHandler(exception) {
            if (window.errorLogger) window.errorLogger.report(exception);
        };
    });
}

import 'core-js/es6/reflect';
import 'core-js/es7/reflect';
import 'zone.js/dist/zone';
if (!Element.prototype.matches) {
    Element.prototype.matches = Element.prototype.msMatchesSelector;
}

import 'hammerjs';

import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppModule } from './app/app.module';

import { UrlService } from '@uirouter/core';
import { NgZone } from '@angular/core';
import { setEditMode } from "@src/store/actions/project-actions";
import { isError } from 'lodash';
import { ReturnStatement } from '@angular/compiler';

angular.element(document).ready(() => {
    platformBrowserDynamic().bootstrapModule(AppModule)
    /* hybrid routing
    .then(platformRef => {
        const urlService = platformRef.injector.get(UrlService);
        const startUIRouter = () => {
            urlService.listen();
            urlService.sync();
        };

        platformRef.injector.get(NgZone).run(startUIRouter);
    });*/
});



// WEBPACK FOOTER //
// ./src/main.js